"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_security(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "10871c62-67cd-4199-9943-c790902feea4",
    "data-name": "security-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192.02 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "721668f4-28ee-45b4-ba93-71d44e739981",
    x1: 90.94,
    y1: 120.85,
    x2: 148.35,
    y2: 178.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "security-hi"), /*#__PURE__*/React.createElement("g", {
    id: "9950f548-e927-42aa-9576-48b1ec71474c",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac97251a-af3f-4eb2-8db1-ba2bc9fe049f",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a019664e-f9eb-4142-b2eb-03177b5c9a6b",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e79276e8-9afc-4064-a7e6-2580f5c19faf",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ba52834c-9d55-49fe-b8fb-6652dc959e14",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "006137ed-f293-47c7-9d0c-019056a52c03",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "17a4beb2-f8c9-492b-a5ed-347c0b0cb291",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dacee3b3-9105-44c8-b64d-18afc978d883",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1a80d30-01b6-4f0e-9eeb-e3aa5b1ebfc0",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3c2f4067-3053-49e0-a0ec-8e85ec8fabc7",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9285dac4-6569-4ef4-ac75-89b3ba3ca05d",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3d6ddc3c-e268-4da4-96c6-8788a08ceccd",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "95b63be1-5985-4f3e-bf57-2d9cd671376e",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "663d5916-488b-4974-9b1f-60f0122a4bbc",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c629d4ac-1d15-4d63-9420-298cfa2ab7ae",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "07e70d29-2af7-4922-b0b6-052d08faf6d3",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1f262d33-5e0c-4a22-a79a-b81698cbbaa3",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12325dd2-3217-4ebc-9959-97b895b9b9a6",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1cdbdfd9-bcb3-4ec3-a43c-f53612e764c0",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3d202b8e-e3d9-4a24-9ed0-9f71e09cecba",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "93f8a4f5-78f9-400f-934e-7a0f08114bd4",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f3eca7f6-021a-4bf1-8246-81f4b319f63d",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "9106640c-38bb-4456-a7d0-a7d67af7b8c9",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,76h-8V56a32,32,0,1,0-64,0V76H56V56a40,40,0,1,1,80,0Z",
    transform: "translate(0.01 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,76h-8V56a32,32,0,1,0-64,0V76H56V56a40,40,0,1,1,80,0Z",
    transform: "translate(0.01 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.83,
    y: 72,
    width: 128.17,
    height: 104,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.02,
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,22A32,32,0,0,0,64,54v2a32,32,0,1,1,64,0V54A32,32,0,0,0,96,22Z",
    transform: "translate(0.01 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,174H47.82a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16v-2A16,16,0,0,1,144,174Z",
    transform: "translate(0.01 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,107.36a9.81,9.81,0,0,1,9.74,8.7c0-.3.07-.59.07-.89a9.81,9.81,0,1,0-19.62,0c0,.3,0,.6.07.89A9.81,9.81,0,0,1,96,107.36Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,105.36a9.81,9.81,0,0,1,4,18.76V148a4,4,0,1,1-8,0V124.12a9.81,9.81,0,0,1,4-18.76m0-4a13.8,13.8,0,0,0-8,25.06V148a8,8,0,1,0,16,0V126.42a13.8,13.8,0,0,0-8-25.06Z",
    transform: "translate(0.01 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,115.17a9.81,9.81,0,1,0-13.81,9V148a4,4,0,0,0,8,0V124.12A9.8,9.8,0,0,0,105.82,115.17Z",
    transform: "translate(0.01 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,105.36a9.81,9.81,0,0,1,4,18.76V148a4,4,0,0,1-8,0V124.12a9.81,9.81,0,0,1,4-18.76m0-4a13.8,13.8,0,0,0-8,25.06V148a8,8,0,0,0,16,0V126.42a13.8,13.8,0,0,0-8-25.06Z",
    transform: "translate(0.01 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.06,105.73A13.77,13.77,0,0,1,104,126.42V148a8,8,0,0,1-11.71,7.08L114,176h30a16,16,0,0,0,16-16v-3Z",
    transform: "translate(0.01 0)",
    fill: "url(#721668f4-28ee-45b4-ba93-71d44e739981)"
  })))))))))))))))))))))))));
}

var _default = ic_security;
exports.default = _default;